export default __webpack_public_path__ + "static/media/social-proof-icon.dc74b146.svg";